import React from "react"
import PropTypes from "prop-types"
import "./marketing.scss"
import "./vodafone-marketing-2.scss"
import Button from "../shared/button/text-button"
import router from "images/splashScreens/vodafone-router.png"
import fastrouter from "images/splashScreens/vodafone-router-fast.jpeg"
import shapes from "images/splashScreens/vodafone-shapes.svg"
import change from "images/splashScreens/vodafone-change.svg"
import clock from "images/splashScreens/vodafone-clock.svg"

const MarketingVodafone2 = ({ handleButtonClick, handleBackButtonClick }) => (
  <div className="marketing-page marketing-page--vodafone-2">
    <h1>With Vodafone you hold the power of broadband in your hands.</h1>
    <div className="marketing-page--info">
      <div className="marketing-page--info--image">
        <img src={router} alt="4G" />
      </div>
      <div className="marketing-page--info--text">
        <p>
          Our award-winning fibre broadband is not only up to 6x faster than the
          UK’s standard broadband, it is also smarter! Our top-spec router and
          our mobile app work together to give you the most advanced broadband
          experience.
        </p>
        <p>
          That means that you can control your broadband with a finger tap to
          make sure your kids don’t see anything they are not supposed to, to
          make sure you get the sleep you need and even to boost your WiFi
          signal for the devices you need it most.
        </p>
      </div>
    </div>
    <div className="marketing-page--extras">
      <p className="bold">
        Super-fast and ultra-smart. Vodafone brings the ultimate broadband
        experience to your home
      </p>
      <div className="thumbnailContainer">
        <div className="row-container">
          <div className="row">
            <img src={clock} alt="" className="vodafone-svg" />
            <div className="row-text-container">
              <p className="bold">
                Ultra-smart Router and Vodafone Broadband App​
              </p>
              <p>
                ​Manage your router from your mobile and control a range of
                handy features and see who’s connected to your network,
              </p>
            </div>
          </div>
          <div className="row">
            <img src={shapes} alt="star icon" className="vodafone-svg" />
            <div className="row-text-container">
              <p className="bold">
                Finally, broadband knows that bedtime means bedtime
              </p>
              <p>
                Family Time lets you control who can use broadband and when. Set
                up your own family network and control who uses what and when.
              </p>
            </div>
          </div>
          <div className="row">
            <img
              src={change}
              alt="network satisfaction stamp logo"
              className="vodafone-svg"
            />
            <div className="row-text-container">
              <p className="bold">Keep everyone safe online​</p>
              <p>
                Keep everyone safe online​ With our content controls tool you
                can protect your kids from inappropriate websites. Also you can
                stop access of viruses and other malware.
              </p>
            </div>
          </div>
        </div>{" "}
        <div className="router-container">
          <img src={fastrouter} alt="" />
          <p>
            Enjoy lightning fast internet speeds with{" "}
            <span className="bold"> Vodafone Gigafast Broadband</span>
          </p>
        </div>
      </div>
    </div>

    <div className="marketing-button-container">
      <Button text="Back" onClick={handleBackButtonClick} />
      <Button text="Continue" onClick={handleButtonClick} />
    </div>
  </div>
)

MarketingVodafone2.propTypes = {
  handleButtonClick: PropTypes.func.isRequired,
  handleBackButtonClick: PropTypes.func.isRequired
}

export default MarketingVodafone2
